// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 100vh;
    background-color: #f1f5f9;
    padding: 20px 10px;
}

.ad-card {
    background-color: #1e293b;
    width: 100%;
    max-width: 680px;
    padding: 28px;
    border-radius: 16px;
    border: 1px solid #334155;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.ad-title {
    color: #f8fafc;
    text-align: center;
    margin-bottom: 24px;
    font-size: 1.4rem;
    font-weight: 600;
    border-bottom: 1px solid #334155;
    padding-bottom: 14px;
}

.ad-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.ad-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.ad-input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.ad-input-group label {
    color: #94a3b8;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.ad-form input,
.ad-form select {
    padding: 11px 14px;
    background-color: #0f172a;
    border: 1px solid #334155;
    color: #f8fafc;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
    width: 100%;
    box-sizing: border-box;
}

.ad-form input:focus,
.ad-form select:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.ad-form input::placeholder {
    color: #475569;
}

.ad-form select option {
    background-color: #1e293b;
    color: #f8fafc;
}

.ad-form input:disabled,
.ad-form select:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.ad-info-badge {
    background: #0f172a;
    border: 1px dashed #3b82f6;
    border-radius: 8px;
    padding: 12px 16px;
    color: #94a3b8;
    font-size: 13px;
}

.ad-info-badge b {
    color: #38bdf8;
}

.ad-submit-btn {
    background-color: #3b82f6;
    color: white;
    padding: 13px;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.2s, transform 0.2s;
    width: 100%;
}

.ad-submit-btn:hover {
    background-color: #2563eb;
    transform: translateY(-1px);
}

.ad-submit-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* Modal */
.pop-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.pop-modal-box {
    background: #1e293b;
    border: 1px solid #334155;
    border-radius: 16px;
    padding: 32px;
    text-align: center;
    width: 90%;
    max-width: 380px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
}

.pop-modal-box h3 {
    color: #f8fafc;
    font-size: 1.3rem;
    margin-bottom: 10px;
}

.pop-modal-box p {
    color: #94a3b8;
    margin-bottom: 20px;
    font-size: 0.95rem;
}

@media (max-width: 600px) {
    .ad-grid {
        grid-template-columns: 1fr;
    }
    .ad-card {
        padding: 18px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DeviceManage/AddDevice.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,WAAW;IACX,sBAAsB;AAC1B;;AAEA;;IAEI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,2CAA2C;IAC3C,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".ad-container {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    min-height: 100vh;\n    background-color: #f1f5f9;\n    padding: 20px 10px;\n}\n\n.ad-card {\n    background-color: #1e293b;\n    width: 100%;\n    max-width: 680px;\n    padding: 28px;\n    border-radius: 16px;\n    border: 1px solid #334155;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n.ad-title {\n    color: #f8fafc;\n    text-align: center;\n    margin-bottom: 24px;\n    font-size: 1.4rem;\n    font-weight: 600;\n    border-bottom: 1px solid #334155;\n    padding-bottom: 14px;\n}\n\n.ad-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.ad-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.ad-input-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.ad-input-group label {\n    color: #94a3b8;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.ad-form input,\n.ad-form select {\n    padding: 11px 14px;\n    background-color: #0f172a;\n    border: 1px solid #334155;\n    color: #f8fafc;\n    border-radius: 8px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.ad-form input:focus,\n.ad-form select:focus {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.ad-form input::placeholder {\n    color: #475569;\n}\n\n.ad-form select option {\n    background-color: #1e293b;\n    color: #f8fafc;\n}\n\n.ad-form input:disabled,\n.ad-form select:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.ad-info-badge {\n    background: #0f172a;\n    border: 1px dashed #3b82f6;\n    border-radius: 8px;\n    padding: 12px 16px;\n    color: #94a3b8;\n    font-size: 13px;\n}\n\n.ad-info-badge b {\n    color: #38bdf8;\n}\n\n.ad-submit-btn {\n    background-color: #3b82f6;\n    color: white;\n    padding: 13px;\n    border: none;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: 600;\n    cursor: pointer;\n    margin-top: 8px;\n    transition: background 0.2s, transform 0.2s;\n    width: 100%;\n}\n\n.ad-submit-btn:hover {\n    background-color: #2563eb;\n    transform: translateY(-1px);\n}\n\n.ad-submit-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n}\n\n/* Modal */\n.pop-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n}\n\n.pop-modal-box {\n    background: #1e293b;\n    border: 1px solid #334155;\n    border-radius: 16px;\n    padding: 32px;\n    text-align: center;\n    width: 90%;\n    max-width: 380px;\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n}\n\n.pop-modal-box h3 {\n    color: #f8fafc;\n    font-size: 1.3rem;\n    margin-bottom: 10px;\n}\n\n.pop-modal-box p {\n    color: #94a3b8;\n    margin-bottom: 20px;\n    font-size: 0.95rem;\n}\n\n@media (max-width: 600px) {\n    .ad-grid {\n        grid-template-columns: 1fr;\n    }\n    .ad-card {\n        padding: 18px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
